import { render, staticRenderFns } from "./UnitStartList.vue?vue&type=template&id=0ab5d72f&scoped=true&"
import script from "./UnitStartList.vue?vue&type=script&lang=js&"
export * from "./UnitStartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5d72f",
  null
  
)

export default component.exports